{
  "sectionId": "config_data",
  "header": "Config",
  "available_actions": null,
  "attributes": [
    {
      "attribute_ID": "lkpDomainId",
      "fieldName": "lkpDomainId",
      "label": "Domain",
      "type": "select",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please select a domain",
      "isAvailable": "Y",
      "placeholder": "Select Domain "
    },
    {
      "attribute_ID": "lkpValueName",
      "fieldName": "lkpValueName",
      "label": "Value",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please enter a value",
      "isAvailable": "Y",
      "placeholder": "Enter a Value"
    },
    {
      "attribute_ID": "lkpValueCode",
      "fieldName": "lkpValueCode",
      "label": "Code",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please enter a code",
      "isAvailable": "Y",
      "placeholder": "Enter a Code"
    },
    {
      "attribute_ID": "lkpValueDesc",
      "fieldName": "lkpValueDesc",
      "label": "Description",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter description",
      "isAvailable": "Y",
      "placeholder": "Description"
    }
  ],
  "validations": [
    {
      "whatToCheck": "atLeastXEntered",
      "clientOrServer": "C",
      "attributes": [
        {
          "validatorid": 1,
          "attribute_ID": ["lkpDomainId"],
          "functionParams": {
            "ErrMsg": "Please select a domain"
          }
        },
        {
          "validatorid": 2,
          "attribute_ID": ["lkpValueName"],
          "functionParams": {
            "ErrMsg": "Please enter a value"
          }
        },
        {
          "validatorid": 3,
          "attribute_ID": ["lkpValueCode"],
          "functionParams": {
            "ErrMsg": "Please enter a code"
          }
        }
      ]
    }
  ],
  "actions": [
    {
      "Name": "Previous",
      "Validate": null
    },
    {
      "Name": "Next",
      "Validate": [
        {
          "checkType": "atLeastXEntered",
          "validatorid": [1, 2, 3]
        }
      ]
    }
  ]
}
